module.exports = __webpack_public_path__ + "img/main-banner-eng.73578f04.png";